// Single source of truth for the backend API base URL.
// All frontend files import API from here instead of defining it locally.
import { dejToken } from './session';
import { aktualniJazyk } from './i18n';
import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Chráněné obrázky (fotky z galerie, avatary, média u příběhů) vyžadují přihlášení.
// Prohlížeč u <img src=".."> neumí poslat hlavičku Authorization, takže token
// připojíme do adresy. Bez přihlášení se obrázek nenačte — a to je záměr.
export function mediaUrl(path) {
  if (!path) return path;
  const backend = process.env.REACT_APP_BACKEND_URL || '';
  const sameOrigin = typeof window !== 'undefined' ? window.location.origin : '';
  // Token připojujeme VÝHRADNĚ na adresy našeho serveru. U cizích URL
  // (obrázek odjinud) by se tím token odeslal třetí straně.
  // Vlastní avatary se ukládají jako plná adresa, proto kontrolujeme i tu —
  // v produkci běží frontend i API na stejné doméně.
  const isOurs =
    path.startsWith('/') ||
    (backend && path.startsWith(backend)) ||
    (sameOrigin && path.startsWith(sameOrigin));
  if (!isOurs) return path;
  const base = path.startsWith('/') ? `${backend}${path}` : path;
  const token = dejToken();
  if (!token) return base;
  return `${base}${base.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
}

// FastAPI returns validation errors (HTTP 422) as detail = [{type, loc, msg, input, ctx}, …].
// Call sites do `toast.error(err.response?.data?.detail || '…')`, so an array of objects would
// be handed to React as a child and crash the app ("Objects are not valid as a React child").
// Normalize detail to a readable string once here, centrally, so every call site gets text.
function formatValidationDetail(detail) {
  if (!Array.isArray(detail)) return detail;
  // Hlášky ze serveru už přeložené chodí; tyhle dvě si doplňujeme sami.
  const anglicky = aktualniJazyk() === 'en';
  const messages = detail.map(item => {
    if (typeof item === 'string') return item;
    const field = Array.isArray(item?.loc) ? item.loc[item.loc.length - 1] : '';
    if (field === 'email') {
      return anglicky ? 'Please enter a valid email address.' : 'Zadejte platnou e-mailovou adresu.';
    }
    // Pydantic prefixes messages from custom validators with "Value error, "
    const msg = (item?.msg || '').replace(/^Value error,\s*/i, '');
    return msg || (anglicky ? 'That value is not valid.' : 'Neplatná hodnota.');
  }).filter(Boolean);
  // De-duplicate — several fields can fail with the same message
  return [...new Set(messages)].join(' ');
}

axios.interceptors.response.use(
  response => response,
  error => {
    const detail = error?.response?.data?.detail;
    if (Array.isArray(detail)) {
      error.response.data.detail = formatValidationDetail(detail);
    }
    return Promise.reject(error);
  }
);
